import type { GridApi } from "ag-grid-community";
import { initGridSettings } from "../../../data";
import { mainColumnTypeMinWidth, type MainColumnType } from "@package/grid-utils";

type MainColumnWidthUpdater = { optimistic: (values: { id: string; main_column_width: number }) => unknown };

export function fitMainMonthColumnToType(
  api: GridApi,
  pageId: string,
  updatePage: MainColumnWidthUpdater,
  type: MainColumnType,
): void {
  const column = api.getColumn("1");
  if (!column) return;

  // Types without a specific fit width (period, month code, count, blank) use the default.
  const desiredWidth = mainColumnTypeMinWidth(type) || initGridSettings.main_month_column_width;
  if (column.getActualWidth() !== desiredWidth) {
    api.setColumnWidths([{ key: "1", newWidth: desiredWidth }], true, "api");
    updatePage.optimistic({ id: pageId, main_column_width: desiredWidth });
  }
}
